export default {
	dots: [
		"⠋",
		"⠙",
		"⠹",
		"⠸",
		"⠼",
		"⠴",
		"⠦",
		"⠧",
		"⠇",
		"⠏"
	],
	dots2: [
		"⣾",
		"⣽",
		"⣻",
		"⢿",
		"⡿",
		"⣟",
		"⣯",
		"⣷"
	],
	dots3: [
		"⠋",
		"⠙",
		"⠚",
		"⠞",
		"⠖",
		"⠦",
		"⠴",
		"⠲",
		"⠳",
		"⠓"
	],
	dots4: [
		"⠄",
		"⠆",
		"⠇",
		"⠋",
		"⠙",
		"⠸",
		"⠰",
		"⠠",
		"⠰",
		"⠸",
		"⠙",
		"⠋",
		"⠇",
		"⠆"
	],
	dots5: [
		"⠋",
		"⠙",
		"⠚",
		"⠒",
		"⠂",
		"⠂",
		"⠒",
		"⠲",
		"⠴",
		"⠦",
		"⠖",
		"⠒",
		"⠐",
		"⠐",
		"⠒",
		"⠓",
		"⠋"
	],
	dots6: [
		"⠁",
		"⠉",
		"⠙",
		"⠚",
		"⠒",
		"⠂",
		"⠂",
		"⠒",
		"⠲",
		"⠴",
		"⠤",
		"⠄",
		"⠄",
		"⠤",
		"⠴",
		"⠲",
		"⠒",
		"⠂",
		"⠂",
		"⠒",
		"⠚",
		"⠙",
		"⠉",
		"⠁"
	],
	dots7: [
		"⠈",
		"⠉",
		"⠋",
		"⠓",
		"⠒",
		"⠐",
		"⠐",
		"⠒",
		"⠖",
		"⠦",
		"⠤",
		"⠠",
		"⠠",
		"⠤",
		"⠦",
		"⠖",
		"⠒",
		"⠐",
		"⠐",
		"⠒",
		"⠓",
		"⠋",
		"⠉",
		"⠈"
	],
	dots8: [
		"⠁",
		"⠁",
		"⠉",
		"⠙",
		"⠚",
		"⠒",
		"⠂",
		"⠂",
		"⠒",
		"⠲",
		"⠴",
		"⠤",
		"⠄",
		"⠄",
		"⠤",
		"⠠",
		"⠠",
		"⠤",
		"⠦",
		"⠖",
		"⠒",
		"⠐",
		"⠐",
		"⠒",
		"⠓",
		"⠋",
		"⠉",
		"⠈",
		"⠈"
	],
	dots9: [
		"⢹",
		"⢺",
		"⢼",
		"⣸",
		"⣇",
		"⡧",
		"⡗",
		"⡏"
	],
	dots10: [
		"⢄",
		"⢂",
		"⢁",
		"⡁",
		"⡈",
		"⡐",
		"⡠"
	],
	dots11: [
		"⠁",
		"⠂",
		"⠄",
		"⡀",
		"⢀",
		"⠠",
		"⠐",
		"⠈"
	],
	dots12: [
		"⢀⠀",
		"⡀⠀",
		"⠄⠀",
		"⢂⠀",
		"⡂⠀",
		"⠅⠀",
		"⢃⠀",
		"⡃⠀",
		"⠍⠀",
		"⢋⠀",
		"⡋⠀",
		"⠍⠁",
		"⢋⠁",
		"⡋⠁",
		"⠍⠉",
		"⠋⠉",
		"⠋⠉",
		"⠉⠙",
		"⠉⠙",
		"⠉⠩",
		"⠈⢙",
		"⠈⡙",
		"⢈⠩",
		"⡀⢙",
		"⠄⡙",
		"⢂⠩",
		"⡂⢘",
		"⠅⡘",
		"⢃⠨",
		"⡃⢐",
		"⠍⡐",
		"⢋⠠",
		"⡋⢀",
		"⠍⡁",
		"⢋⠁",
		"⡋⠁",
		"⠍⠉",
		"⠋⠉",
		"⠋⠉",
		"⠉⠙",
		"⠉⠙",
		"⠉⠩",
		"⠈⢙",
		"⠈⡙",
		"⠈⠩",
		"⠀⢙",
		"⠀⡙",
		"⠀⠩",
		"⠀⢘",
		"⠀⡘",
		"⠀⠨",
		"⠀⢐",
		"⠀⡐",
		"⠀⠠",
		"⠀⢀",
		"⠀⡀"
	],
	dots13: [
		"⣼",
		"⣹",
		"⢻",
		"⠿",
		"⡟",
		"⣏",
		"⣧",
		"⣶"
	],
	dots14: [
		"⠉⠉",
		"⠈⠙",
		"⠀⠹",
		"⠀⢸",
		"⠀⣰",
		"⢀⣠",
		"⣀⣀",
		"⣄⡀",
		"⣆⠀",
		"⡇⠀",
		"⠏⠀",
		"⠋⠁"
	],
	dotsCircle: [
		"⢎ ",
		"⠎⠁",
		"⠊⠑",
		"⠈⠱",
		" ⡱",
		"⢀⡰",
		"⢄⡠",
		"⢆⡀"
	],
	sand: [
		"⠁",
		"⠂",
		"⠄",
		"⡀",
		"⡈",
		"⡐",
		"⡠",
		"⣀",
		"⣁",
		"⣂",
		"⣄",
		"⣌",
		"⣔",
		"⣤",
		"⣥",
		"⣦",
		"⣮",
		"⣶",
		"⣷",
		"⣿",
		"⡿",
		"⠿",
		"⢟",
		"⠟",
		"⡛",
		"⠛",
		"⠫",
		"⢋",
		"⠋",
		"⠍",
		"⡉",
		"⠉",
		"⠑",
		"⠡",
		"⢁"
	],
	line: [
		"-",
		"\\",
		"|",
		"/"
	],
	line2: [
		"⠂",
		"-",
		"–",
		"—",
		"–",
		"-"
	],
	pipe: [
		"┤",
		"┘",
		"┴",
		"└",
		"├",
		"┌",
		"┬",
		"┐"
	],
	simpleDots: [
		".  ",
		".. ",
		"...",
		"   "
	],
	simpleDotsScrolling: [
		".  ",
		".. ",
		"...",
		" ..",
		"  .",
		"   "
	],
	star: [
		"✶",
		"✸",
		"✹",
		"✺",
		"✹",
		"✷"
	],
	star2: [
		"+",
		"x",
		"*"
	],
	flip: [
		"_",
		"_",
		"_",
		"-",
		"`",
		"`",
		"'",
		"´",
		"-",
		"_",
		"_",
		"_"
	],
	hamburger: [
		"☱",
		"☲",
		"☴"
	],
	growVertical: [
		"▁",
		"▃",
		"▄",
		"▅",
		"▆",
		"▇",
		"▆",
		"▅",
		"▄",
		"▃"
	],
	growHorizontal: [
		"▏",
		"▎",
		"▍",
		"▌",
		"▋",
		"▊",
		"▉",
		"▊",
		"▋",
		"▌",
		"▍",
		"▎"
	],
	balloon: [
		" ",
		".",
		"o",
		"O",
		"@",
		"*",
		" "
	],
	balloon2: [
		".",
		"o",
		"O",
		"°",
		"O",
		"o",
		"."
	],
	noise: [
		"▓",
		"▒",
		"░"
	],
	bounce: [
		"⠁",
		"⠂",
		"⠄",
		"⠂"
	],
	boxBounce: [
		"▖",
		"▘",
		"▝",
		"▗"
	],
	boxBounce2: [
		"▌",
		"▀",
		"▐",
		"▄"
	],
	triangle: [
		"◢",
		"◣",
		"◤",
		"◥"
	],
	binary: [
		"010010",
		"001100",
		"100101",
		"111010",
		"111101",
		"010111",
		"101011",
		"111000",
		"110011",
		"110101"
	],
	arc: [
		"◜",
		"◠",
		"◝",
		"◞",
		"◡",
		"◟"
	],
	circle: [
		"◡",
		"⊙",
		"◠"
	],
	squareCorners: [
		"◰",
		"◳",
		"◲",
		"◱"
	],
	circleQuarters: [
		"◴",
		"◷",
		"◶",
		"◵"
	],
	circleHalves: [
		"◐",
		"◓",
		"◑",
		"◒"
	],
	squish: [
		"╫",
		"╪"
	],
	toggle: [
		"⊶",
		"⊷"
	],
	toggle2: [
		"▫",
		"▪"
	],
	toggle3: [
		"□",
		"■"
	],
	toggle4: [
		"■",
		"□",
		"▪",
		"▫"
	],
	toggle5: [
		"▮",
		"▯"
	],
	toggle6: [
		"ဝ",
		"၀"
	],
	toggle7: [
		"⦾",
		"⦿"
	],
	toggle8: [
		"◍",
		"◌"
	],
	toggle9: [
		"◉",
		"◎"
	],
	toggle10: [
		"㊂",
		"㊀",
		"㊁"
	],
	toggle11: [
		"⧇",
		"⧆"
	],
	toggle12: [
		"☗",
		"☖"
	],
	toggle13: [
		"=",
		"*",
		"-"
	],
	arrow: [
		"←",
		"↖",
		"↑",
		"↗",
		"→",
		"↘",
		"↓",
		"↙"
	],
	arrow2: [
		"⬆️ ",
		"↗️ ",
		"➡️ ",
		"↘️ ",
		"⬇️ ",
		"↙️ ",
		"⬅️ ",
		"↖️ "
	],
	arrow3: [
		"▹▹▹▹▹",
		"▸▹▹▹▹",
		"▹▸▹▹▹",
		"▹▹▸▹▹",
		"▹▹▹▸▹",
		"▹▹▹▹▸"
	],
	bouncingBar: [
		"[    ]",
		"[=   ]",
		"[==  ]",
		"[=== ]",
		"[====]",
		"[ ===]",
		"[  ==]",
		"[   =]",
		"[    ]",
		"[   =]",
		"[  ==]",
		"[ ===]",
		"[====]",
		"[=== ]",
		"[==  ]",
		"[=   ]"
	],
	bouncingBall: [
		"( ●    )",
		"(  ●   )",
		"(   ●  )",
		"(    ● )",
		"(     ●)",
		"(    ● )",
		"(   ●  )",
		"(  ●   )",
		"( ●    )",
		"(●     )"
	],
	smiley: [
		"😄 ",
		"😝 "
	],
	monkey: [
		"🙈 ",
		"🙈 ",
		"🙉 ",
		"🙊 "
	],
	hearts: [
		"💛 ",
		"💙 ",
		"💜 ",
		"💚 ",
		"❤️ "
	],
	clock: [
		"🕛 ",
		"🕐 ",
		"🕑 ",
		"🕒 ",
		"🕓 ",
		"🕔 ",
		"🕕 ",
		"🕖 ",
		"🕗 ",
		"🕘 ",
		"🕙 ",
		"🕚 "
	],
	earth: [
		"🌍 ",
		"🌎 ",
		"🌏 "
	],
	moon: [
		"🌑 ",
		"🌒 ",
		"🌓 ",
		"🌔 ",
		"🌕 ",
		"🌖 ",
		"🌗 ",
		"🌘 "
	],
	runner: [
		"🚶 ",
		"🏃 "
	],
	dqpb: [
		"d",
		"q",
		"p",
		"b"
	],
	weather: [
		"☀️ ",
		"☀️ ",
		"☀️ ",
		"🌤 ",
		"⛅️ ",
		"🌥 ",
		"☁️ ",
		"🌧 ",
		"🌨 ",
		"🌧 ",
		"🌨 ",
		"🌧 ",
		"🌨 ",
		"⛈ ",
		"🌨 ",
		"🌧 ",
		"🌨 ",
		"☁️ ",
		"🌥 ",
		"⛅️ ",
		"🌤 ",
		"☀️ ",
		"☀️ "
	],
	christmas: [
		"🌲",
		"🎄"
	],
	grenade: [
		"،  ",
		"′  ",
		" ´ ",
		" ‾ ",
		"  ⸌",
		"  ⸊",
		"  |",
		"  ⁎",
		"  ⁕",
		" ෴ ",
		"  ⁓",
		"   ",
		"   ",
		"   "
	],
	point: [
		"∙∙∙",
		"●∙∙",
		"∙●∙",
		"∙∙●",
		"∙∙∙"
	],
	layer: [
		"-",
		"=",
		"≡"
	],
	betaWave: [
		"ρββββββ",
		"βρβββββ",
		"ββρββββ",
		"βββρβββ",
		"ββββρββ",
		"βββββρβ",
		"ββββββρ"
	],
	fingerDance: [
		"🤘 ",
		"🤟 ",
		"🖖 ",
		"✋ ",
		"🤚 ",
		"👆 "
	],
	mindblown: [
		"😐 ",
		"😐 ",
		"😮 ",
		"😮 ",
		"😦 ",
		"😦 ",
		"😧 ",
		"😧 ",
		"🤯 ",
		"💥 ",
		"✨ ",
		"\u3000 ",
		"\u3000 ",
		"\u3000 "
	],
	speaker: [
		"🔈 ",
		"🔉 ",
		"🔊 ",
		"🔉 "
	],
	orangePulse: [
		"🔸 ",
		"🔶 ",
		"🟠 ",
		"🟠 ",
		"🔶 "
	],
	bluePulse: [
		"🔹 ",
		"🔷 ",
		"🔵 ",
		"🔵 ",
		"🔷 "
	],
	orangeBluePulse: [
		"🔸 ",
		"🔶 ",
		"🟠 ",
		"🟠 ",
		"🔶 ",
		"🔹 ",
		"🔷 ",
		"🔵 ",
		"🔵 ",
		"🔷 "
	],
	timeTravel: [
		"🕛 ",
		"🕚 ",
		"🕙 ",
		"🕘 ",
		"🕗 ",
		"🕖 ",
		"🕕 ",
		"🕔 ",
		"🕓 ",
		"🕒 ",
		"🕑 ",
		"🕐 "
	],
	aesthetic: [
		"▰▱▱▱▱▱▱",
		"▰▰▱▱▱▱▱",
		"▰▰▰▱▱▱▱",
		"▰▰▰▰▱▱▱",
		"▰▰▰▰▰▱▱",
		"▰▰▰▰▰▰▱",
		"▰▰▰▰▰▰▰",
		"▰▱▱▱▱▱▱"
	]
}
